<div class="col-md-6 offset-md-3 mt-5">
  <div class="navbar-header" style="background-color: whitesmoke; height: 20%">
    <a class="" rel="studentDetails" href="#" title="Student Details"> </a>
  </div>
</div>

<div class="col-md-6 offset-md-3 mt-5">
  <div class="navbar-header">
    <a class="" rel="studentDetails" href="#" >
      <img
        class="responsive"
        style="width: 100%; height: auto"
        src="assets/images/header-1.png"
      />
    </a>
  </div>

  <section
    id="header"
    class="rounded"
    style="
      margin-top: 1%;
      background-color: white;
      text-align: center;
      text-emphasis-color: inherit;
    "
  >
    <div class="container">
      <div class="row">
        <div
          class="col-md-12 col-xs-12 col-centered"
          style="align-items: center; text-decoration: underline"
        >
          <strong> PAYMENT DETAILS </strong>
        </div>
      </div>
    </div>
  </section>

  <div class="card" style="margin-top: 1%">

    <div class="card-body">
      <div *ngIf="!myDIV">
        <form [formGroup]="form">

          <div class="form-group">
            <mat-form-field style="width:100%">
              <mat-label>Contract No</mat-label>
              <input type="text" maxlength="25" minlength="14" matInput placeholder="Enter Contract No" formControlName="contractNo"
                autocomplete="off" required />
              <mat-error *ngIf="form.controls['contractNo'].hasError('required')">Contract No is required.</mat-error>
              <mat-error *ngIf="form.controls['contractNo'].hasError('pattern')">Invalid Contract No</mat-error>
            </mat-form-field>
          </div>

          <div *ngIf="studentData" style="display: flex; margin-top: 30px; color: #02771f; justify-content: space-evenly;">
            <mat-label >Contract No is Verified.</mat-label>
           <mat-icon *ngIf="verified" style="color: green;">check</mat-icon>
        </div>     

          <div>
            <mat-form-field style="width:100%">
              <mat-label>Contract Amount</mat-label>
              <input type="text" maxlength="40" matInput placeholder="Enter Contract Amount" formControlName="totalAmount" autocomplete="off" required />
              <mat-error *ngIf="form.controls['totalAmount'].hasError('required')">Contract Amount is required.</mat-error>
              <mat-error *ngIf="form.controls['totalAmount'].hasError('pattern')">Invalid Contract Amount</mat-error>
            </mat-form-field>
          </div>

          <div class="form-group">
            <label> Captcha <span>*</span></label>
            <input matInput  onpaste="return false;" onCopy="return false" onCut="return false" placeholder="Enter Captcha"
               class="captchaFeild"  formControlName="captcha" autocomplete="off"
              minlength="6" maxlength="6"  onkeyup="this.value = this.value.toUpperCase();"  class="form-control" [ngClass]="{ 'is-invalid': submitted && f.captcha.errors }" style="border: 1px solid black;" required />
              <div *ngIf="submitted && f.captcha.errors " class="invalid-feedback">
                <div *ngIf="f.captcha.errors.required">Captcha is required</div>
                <div *ngIf="f.captcha.errors.incorrectcaptcha && (!f.captcha.errors.required)">Captcha is Invalid. </div>
                <div *ngIf="f.captcha.errors.minlength && (!f.captcha.errors.required)">Captcha required of length {{f.captcha.errors.minlength.requiredLength}} and has length {{f.captcha.errors.minlength.actualLength}}  </div>
              </div>
           </div>
           <div id="capt">
              <span onselectstart="return false" onpaste="return false;" onCopy="return false" onCut="return false" onDrag="return false" onDrop="return false">{{initialCap}}</span>
              <span style="float: right; cursor: pointer;">
                      <i class="material-icons" (click)="Cap()">refresh</i>
              </span>
         </div> 


          <div class="form-group" style="display: flex; margin-top: 30px; justify-content: space-evenly;">
            <button #submitButton style="width: 129px;" class="btn btn-primary" type="submit" (click)="submitContractDetails()">            
              PAY NOW
            </button>
          </div>
         
           
        </form>

          <div class="errBackButtonDiv" style="width: 129px !important; margin-top: 30px; margin-bottom: 20px;">

          </div>

      </div>
      <div>
        <form
          target="_top"
          #txnForm
          [formGroup]="tranxnForm"
          method="POST"
          action="{{ isgPay_url }}"
        >
          <input
            type="hidden"
            [value]="EncDataField"
            name="EncData"
            formControlName="EncData"
          />
          <input
            type="hidden"
            [value]="MerchantIdField"
            name="MerchantId"
            formControlName="MerchantId"
          />
          <input
            type="hidden"
            [value]="BankIdField"
            name="BankId"
            formControlName="BankId"
          />
          <input
            type="hidden"
            [value]="TerminalIdField"
            name="TerminalId"
            formControlName="TerminalId"
          />
          <input
            type="hidden"
            [value]="VersionField"
            name="Version"
            formControlName="Version"
          />
          <input
            type="hidden"
            [value]="TransactionId"
            name="OrderId"
            formControlName="TransactionId"
          />
        </form>
      </div>
    </div>
  </div>
</div>
